import { FC } from 'react'
import Map, {  Marker } from 'react-map-gl';
import './precipitacionmap.css'
import mapboxgl from 'mapbox-gl';
import { FaWarehouse } from 'react-icons/fa';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

export const PrecipitacionMap:FC<any> = (props):JSX.Element => {

  const { mapData } = props


    return (
        <div className='precipitacionmap__wrapper'>
            <Map
                initialViewState={{
                longitude: -1.28283,
                latitude: 42.57483,
                zoom: 10
                }}
                
                mapStyle="mapbox://styles/mapbox/dark-v10"
                mapboxAccessToken='pk.eyJ1Ijoic3VwcG9ydGxpcyIsImEiOiJjbHJvdjN2dmgxZGQ3Mm1xcnk5ZTd2bTBzIn0.qpaZq5DgY3uadTS5JY_-7A'
            >
                {
                  mapData?.map((data:any,index:number) => {
                    return (
                      <Marker
                        key={index}
                        latitude={data.latitude} // Supongo que tienes una propiedad "latitud" en tu objeto
                        longitude={data.longitude} // Supongo que tienes una propiedad "longitud" en tu objeto
                        style={{display:'flex',flexDirection:'column',alignItems:'center'}}
                      >
                        {/* Aquí puedes personalizar el marcador, por ejemplo, con un ícono o texto */}
                        <FaWarehouse style={{color:'white',zIndex:1,cursor:'pointer'}} />
                        <small style={{color:'white',fontSize:'0.5rem'}}>{data.warehouse}</small>
                      </Marker>
                      
                    )
                  })
                }
                
            </Map>
        </div>
    )
}